/*
##
## July 8, 2025
## - Checkout button disabled
##
*/

jQuery(function($){
  var win_width = $(window).width();

  var header = $('.header_v2 .main'),
      header_overlay = $('.header_v2 .bg_overlay'),
      header_haschild = header.find('.has_child'),
      header_childmenu = header_haschild.find('.child_menu'),
      shouldShowChild = false,
      timeout,
      timeout_count = 500;
  header_haschild.mouseenter(function() {
      clearTimeout(timeout);
      shouldShowChild = true;
      // $('body').addClass('scroll_disable');
      $(this).find('.child_menu').show();
      header_overlay.show();
  });

  header_haschild.mouseleave(function() {
      var child = $(this).find('.child_menu');
      shouldShowChild = false;
      timeout = setTimeout(function() {
        if (!shouldShowChild) {
          // $('body').removeClass('scroll_disable');
          child.hide();
          header_overlay.hide();
        }
      }, timeout_count);
  });

  header_childmenu.mouseenter(function() {
    clearTimeout(timeout);
    shouldShowChild = true;
  });

  header_childmenu.mouseleave(function() {
    var child = $(this);
    shouldShowChild = false;
    timeout = setTimeout(function() {
      if (!shouldShowChild) {
        // $('body').removeClass('scroll_disable');
        child.hide();
        header_overlay.hide();
      }
    }, timeout_count);
  });

  var menu_drawer = $('.menu_drawer'),
      drawer_close = menu_drawer.find('.close'),
      has_child = menu_drawer.find('.has_child'),
      has_child_child = menu_drawer.find('.child_menu_item');
  $('.menu_btn').click(function(){
    menu_drawer.toggleClass('show_drawer');
    $('body').toggleClass('scroll_disable');
  });

  drawer_close.click(function(){
    menu_drawer.removeClass('show_drawer');
    $('body').removeClass('scroll_disable');
  });

  has_child.click(function(e){
    var child_menu = $(this).find('.child_menu');

    if (!$(e.target).closest(has_child_child).length) {
      child_menu.slideToggle();
    }
  });

  has_child_child.click(function(e){
    var child_child_menu = $(this).find('.child_child_menu');
    child_child_menu.slideToggle();
  });

  var header_search = $('.header_search'),
      header_search_close = header_search.find('.close_search'),
      header_search_input = header_search.find('.search-input'),
      header_search_recommended = header_search.find('.recommended');
  $('.search_btn').click(function(e){
    e.preventDefault();
    header_search.fadeIn();
    $('body').addClass('scroll_disable');
  });

  header_search_close.click(function(e){
    e.preventDefault();
    header_search.fadeOut();
    $('body').removeClass('scroll_disable');
    // if ( header_search_recommended.length > 0 ) {
    //   header_search_recommended.hide();
    // }
  });

  // header_search_input.focusin(function(){
  //   if ( header_search_recommended.length > 0 ) {
  //     header_search_recommended.show();
  //   }
  // });

  var recom_slide = $('.recom_slide');
  if ( recom_slide.length > 0 ) {
    var prod_swipe = new Swiper(".recom_slide .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".recom_slide .next",
        prevEl: ".recom_slide .prev",
      },
      breakpoints: {
        1025: {
          slidesPerView: 2
        },
        1025: {
          slidesPerView: 3
        }
      }
    });
  }

  var info_slide = $('.info .swiper-container'),
      info_init = false,
      info_marquee,
      info_item_clone = false;
  if ( info_slide.length > 0 ) {
    $(window).on('resize', info_marquee_slide);

    info_marquee_slide();
  }

  function info_marquee_slide() {
    var curr_win_width = $(window).width(),
        info_slide_wrap = info_slide.find('.swiper-wrapper'),
        info_slide_item = info_slide_wrap.find('.swiper-slide');

    if ( curr_win_width < 768 ) {
      if ( !info_init ) {
        if ( !info_item_clone ) {
          info_slide_item.each(function(){
            $(this).clone().addClass('clone').appendTo(info_slide_wrap);
          });

          info_item_clone = true;
        }

        info_init = true;
        info_marquee = new Swiper('.info .swiper-container', {
          spaceBetween: 50,
          centeredSlides: true,
          speed: 6000,
          autoplay: {
            delay: 1,
          },
          loop: true,
          slidesPerView:'auto',
          allowTouchMove: false,
          disableOnInteraction: true,
          loopFillGroupWithBlank: true
        });
      }
    } else if ( info_init ) {
      info_slide_wrap.find('.clone').remove();
      info_item_clone = false;

      info_marquee.destroy();
      info_init = false;
    }
  }

  var accord = $('.faq_accord');
  if ( accord.length > 0 ) {
    var accord_item = accord.find('.accord_item'),
        accord_title = accord_item.find('.accord_title'),
        accord_desc = accord_item.find('.accord_desc');

    accord_title.click(function(){
      var this_par = $(this).parent(),
          this_sib = $(this).siblings('.accord_desc');

      if ( this_par.hasClass('active') ) {
        this_par.removeClass('active');
        this_sib.slideUp();
      } else {
        accord_item.not(this_par).removeClass('active');
        accord_desc.not(this_sib).slideUp();
        
        this_par.addClass('active');
        this_sib.slideDown();
      }
      
    });
  }

  var search_accord = $('.search_filter'),
      search_fil = search_accord.find('.facets__header'),
      search_form = search_accord.find('.search-form');
  if ( search_fil.length > 0 ) {
    search_fil.click(function(){
      var accord_status = search_accord.attr('open');
      if ( accord_status ) {
        search_accord.removeAttr('open');
        search_form.hide();
      } else {
        search_accord.attr('open', true);
        search_form.show();
      }
    });
  }

  var prod_slide = $('.prod_slider');
  if ( prod_slide.length > 0 ) {
    var prod_swipe = new Swiper(".prod_slider .swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 24,
      navigation: {
        nextEl: ".prod_slider .next",
        prevEl: ".prod_slider .prev",
      },
      breakpoints: {
        1025: {
          slidesPerView: 4
        }
      }
    });
  }

  var testi_slide = $('.testi_slider'),
      testi_slide_item = testi_slide.find('.swiper-slide'),
      initial_slide = 2;
  if ( testi_slide.length > 0 ) {
    var testi_swipe = new Swiper(".testi_slider .thumb_slide .swiper-container", {
      slidesPerView: "auto",
      centeredSlides: true,
      allowTouchMove: true,
      noSwiping: false,
      initialSlide: initial_slide,
      breakpoints: {
        1025 : {
          allowTouchMove: false,
          noSwiping: true,
          loop: false,
        }
      }
    });

    testi_content(initial_slide);

    testi_slide_item.click(function(){
      var this_index = $(this).index();
      testi_swipe.slideTo(this_index);
      testi_content(this_index);
    });

    testi_swipe.on('slideChange', function () {
      var change_index = testi_swipe.realIndex;
      testi_content(change_index);
    });

    function testi_content($index) {
      var testi_content = testi_slide.find('.testi_content'),
          content_list = testi_content.find('.content'),
          index_content = content_list.eq($index);

      content_list.not(index_content).removeClass('show_content');
      index_content.addClass('show_content');
    }
  }

  var prod_imgs = $('.product_img'),
      prod_thumb = prod_imgs.find('.thumb_slide');
  if ( prod_thumb.length > 0 ) {
    var thumb_swipe;
    var main_swiper;
    
    function initProductSliders() {
      // Destroy existing swipers if they exist
      if (thumb_swipe) thumb_swipe.destroy(true, true);
      if (main_swiper) main_swiper.destroy(true, true);
      
      // Initialize thumb swiper
      thumb_swipe = new Swiper(".thumb_slide .swiper-container", {
        direction: "horizontal",
        spaceBetween: 20,
        slidesPerView: 3,
        autoHeight: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
          400: {
            slidesPerView: 4
          },
          768: {
            slidesPerView: 'auto',
            direction: "vertical",
            autoHeight: true,
            spaceBetween: 16
          }
        }
      });

      // Initialize main swiper
      main_swiper = new Swiper(".main_slide .swiper-container", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".main_slide .next",
          prevEl: ".main_slide .prev",
        },
        thumbs: {
          swiper: thumb_swipe
        }
      });
    }

    function main_image_height() {
      if (window.innerHeight <= 800 || window.innerWidth >= 768) {
        $('.main_product .img_col .main_slide img').css('height', '');
        return;
      }
      
      var announcement_bar = $('.announcement_bar'),
          announcement_bar_height = announcement_bar.length ? announcement_bar.outerHeight() : 0,
          main_header = $('.header_v2 .main'),
          main_header_height = main_header.length ? main_header.outerHeight() : 0,
          info_header = $('.header_v2 .info'),
          info_header_height = info_header.length ? info_header.outerHeight() : 0,
          header_size = announcement_bar_height + main_header_height + info_header_height,
          thumb_height = prod_thumb.outerHeight() || 0,
          main_image_position = $('.main_product .img_col .main_slide').offset().top,
          prod_desc = $('.main_product .desc_col'),
          prod_title = prod_desc.find('.prod_title_mob'),
          prod_price = prod_desc.find('.prod_price_mob'),
          prod_title_height = prod_title.length ? prod_title.outerHeight() : 0,
          prod_price_height = prod_price.length ? prod_price.outerHeight() : 0,
          prod_desc_height = prod_title_height + prod_price_height,
          main_image_height = header_size + thumb_height + prod_desc_height + main_image_position + 70;

      // Set the image height based on calculations
      $('.main_product .img_col .main_slide img').css('height', 'calc(100dvh - ' + main_image_height + 'px)');
      console.log('prod_title_height: ' + prod_title.outerHeight());
      console.log('prod_price_height: ' + prod_price.outerHeight());
      console.log('main_image_height: ' + main_image_height);
    }

    // Initial initialization
    initProductSliders();
    
    // Wait for images to load before calculating height
    $(window).on('load', function() {
      setTimeout(main_image_height, 300); // Small delay to ensure all elements are rendered
    });

    // Reinitialize on window resize
    let resizeTimer;
    $(window).on('resize', function() {
      initProductSliders();
      
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        main_image_height(); // Call the function directly here
      }, 300);
    });
  }

  var cart_intervalDuration = .1 * 60 * 60 * 1000;
  $('.header__icon').click(function(){
    setTimeout(function(){
      const cart_count = $('.cart_countdown');
      if ( cart_count.length > 0 ) {
        function startCountdown() {
          var countDownDate = new Date().getTime() + cart_intervalDuration;

          
            var hours_elem = cart_count.find('.hours'),
                min_elem = cart_count.find('.minutes');

          var countdownFunction = setInterval(function () {
              var now = new Date().getTime();
              var distance = countDownDate - now;

              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

              hours_elem.text(hours);
              min_elem.text(minutes);

              if (distance < 0) {
                  clearInterval(countdownFunction);
                  hours_elem.text('0');
                  min_elem.text('0');
              }
          }, 1000);
        }startCountdown();
      }
    },800);
  });

  var prod_mob_btn = $('.main_product .mobile_form'),
      prod_mob_btn_qty = prod_mob_btn.find('#Quantity-mobile'),
      prod_mob_btn_var = prod_mob_btn.find('.mobile_option'),
      prod_mob_sticky = $('.desk_form'),
      prod_mob_sticky_qty = prod_mob_sticky.find('#Quantity-desk'),
      prod_mob_sticky_var = prod_mob_sticky.find('variant-radios input[type="radio"]'),
      prod_select = prod_mob_sticky.find('.variant-select');

  // if ( prod_mob_btn.length > 0 && prod_mob_sticky.length > 0 ) {
  if ( prod_mob_sticky.length > 0 ) {
    // $(window).scroll(function(){
    //   var win_scroll = $(this).scrollTop(),
    //       mob_btn_top = prod_mob_btn.offset().top,
    //       mob_btn_height = prod_mob_btn.outerHeight();
    //       mob_btn_bot = mob_btn_top + mob_btn_height;

    //   if ( win_scroll >= mob_btn_bot ) {
    //     prod_mob_sticky.addClass('show_btn');
    //   } else {
    //     prod_mob_sticky.removeClass('show_btn');
    //   }
    // });

    prod_mob_sticky_qty.change(function(){
      var this_val = $(this).val();

      change_qty($(this), prod_mob_btn_qty);
    });

    prod_mob_btn_qty.change(function(){
      change_qty($(this), prod_mob_sticky_qty);
    });

    prod_mob_sticky_var.change(function(){
      change_option($(this), prod_mob_btn_var);
    });

    prod_mob_btn_var.change(function(){
      change_option($(this), prod_mob_sticky_var);
    });

    prod_select.change(function(){
      change_option($(this));
    });

    function change_qty($elem, $target) {
      var this_val = $elem.val();

      $target.val(this_val);
    }

    var variantID;
    function change_option($elem, $target) {
      var this_option_val = $elem.data('option-value');

      if ( $target ) {
        $target.each(function(){
          var target_option_val = $(this).data('option-value');
          if ( this_option_val === target_option_val ) {
            $(this).prop('checked', true);
          }
        });

        setTimeout(function(){
          variantID = getUrlParameter('variant');

          $elem.parents('.product-form__buttons').siblings('input[name="id"]').val(variantID);
          $target.parents('.product-form__buttons').siblings('input[name="id"]').val(variantID);
        }, 100);
      }


      if ( $elem.hasClass('color_radio') || $elem.hasClass('height_radio') || $elem.hasClass('size_radio') ) {
        var target_color = $elem.val(),
            prod_imgs = $('.product_img, .img_popup_variant').find('.img_color_option');

        prod_imgs.each(function(){
          var this_option_id = $(this).data('option-id');
          if ( target_color == this_option_id ) {
            $(this).siblings().removeClass('active_img');

            $(this).addClass('active_img');

            console.log('this_option_id: ' + this_option_id);
            console.log('target_color: ' + target_color); 
          }
        });
      }
    }

    function getUrlParameter(name) {
      var url = window.location.href;
      var regex = new RegExp("[?&]" + name + "=([^&#]*)");
      var results = regex.exec(url);
      return results === null ? "" : decodeURIComponent(results[1]);
    }
  }

  var prod_desc = $('.prod_desc');
  if ( prod_desc.length > 0 ) {
    var desc_label = prod_desc.find('.desc_label'),
        desc_content = prod_desc.find('.desc_content');
    desc_label.click(function(){
      var this_parent = $(this).parent(),
          sib_content = $(this).siblings('.desc_content');

      if ( this_parent.hasClass('active') ) {
        this_parent.removeClass('active');
        sib_content.slideUp();
      } else {
        prod_desc.not(this_parent).removeClass('active');
        desc_content.not(sib_content).slideUp();

        this_parent.addClass('active');
        sib_content.slideDown();
      }
    });
  }

  document.addEventListener('cartdrawer:opened', cart_coundown);

  document.addEventListener('cart:updated', cart_coundown);

  function cart_coundown() {
    var elem_countdown_count = $('.countdown_count');
    var elem_countdown_expire = $('.countdown_expire');
    var elem_countdown = elem_countdown_count.find('.cart_countdown');
    
    // Get current time in UK (London timezone)
    var now = new Date();
    // Convert to UK time
    var ukTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' }));
    
    // Set 3:00 PM in UK time
    var threePM = new Date(ukTime);
    threePM.setHours(15, 0, 0, 0);
    
    // Get day of week in UK time
    var dayOfWeek = ukTime.getDay();

    if (ukTime >= threePM) {
      elem_countdown_count.hide();
      elem_countdown_expire.show();
      if (dayOfWeek === 5) {
        elem_countdown_expire.text("Your order will be dispatched on Monday");
      } else {
        elem_countdown_expire.text("Your order will be dispatched tomorrow");
      }
    } else {
      var remainingTime = Math.floor((threePM - ukTime) / 1000);

      elem_countdown_expire.hide();
      elem_countdown_count.show();

      if (remainingTime > 2 * 3600) {
        var hours = Math.floor(remainingTime / 3600);
        elem_countdown.text(hours + "h");
      } else {
        var minutes = Math.floor(remainingTime / 60);
        elem_countdown.text(minutes + "m");
      }
    }

    // Set up next update
    setTimeout(function() {
      cart_coundown();
    }, 60000); // Update every minute instead of every second to reduce load
    
    // Calculate time until midnight UK time for reset
    var nextMidnight = new Date(ukTime);
    nextMidnight.setDate(nextMidnight.getDate() + 1);
    nextMidnight.setHours(0, 0, 0, 0);
    var timeUntilMidnight = nextMidnight - ukTime;
    
    // Set up midnight reset (UK time)
    setTimeout(function() {
      cart_coundown(); // Reset at midnight UK time
    }, timeUntilMidnight); 
  } 

  // Product form scroll handler for mobile
  var productForm = $('.product-form');
  if (productForm.length > 0) {
    // Function to handle product form visibility on scroll
    function handleProductFormScroll() {
      if (window.innerWidth < 768) { // Mobile only
        var scrollTop = $(window).scrollTop();
        
        if (scrollTop > 0) {
          productForm.addClass('scrolled_down');
        } else if (scrollTop === 0) { // Remove class when at the top
          productForm.removeClass('scrolled_down');
        }
      } else {
        productForm.removeClass('scrolled_down');
      }
    }
    
    // Attach event listeners
    $(window).on('scroll', handleProductFormScroll);
    $(window).on('resize', handleProductFormScroll);
    
    // Initial check
    handleProductFormScroll();
  }
});

/**
 * Auto Add/Remove Free Gift Product
 * Automatically adds a free gift product to cart when threshold is met
 * and removes it when threshold is no longer met
 */
// Add a debounce flag to prevent multiple executions in quick succession
let freeGiftProcessing = false;
let freeGiftTimeout = null;

// Helper function to enable the mini cart final button
function enableMiniCartButton() {
  // Try multiple selectors for the checkout button
  const buttonSelectors = [
    '.mini-cart_final_button',
    '.cart__checkout-button',
    '.cart-drawer__checkout-button',
    '[name="add"][type="submit"]',
    '.btn--checkout'
  ];
  
  buttonSelectors.forEach(selector => {
    const button = document.querySelector(selector);
    if (button) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    }
  });
  
  // Also try jQuery selectors as fallback
  if (typeof $ !== 'undefined') {
    $('.mini-cart_final_button, .cart__checkout-button, .cart-drawer__checkout-button').each(function() {
      $(this).removeAttr('disabled').removeClass('disabled');
    });
  }
}

// Helper function to disable the mini cart final button
function disableMiniCartButton() {
  // Try multiple selectors for the checkout button
  const buttonSelectors = [
    '.mini-cart_final_button',
    '.cart__checkout-button',
    '.cart-drawer__checkout-button',
    '[name="add"][type="submit"]',
    '.btn--checkout'
  ];
  
  buttonSelectors.forEach(selector => {
    const button = document.querySelector(selector);
    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    }
  });
  
  // Also try jQuery selectors as fallback
  if (typeof $ !== 'undefined') {
    $('.mini-cart_final_button, .cart__checkout-button, .cart-drawer__checkout-button').each(function() {
      $(this).attr('disabled', 'disabled').addClass('disabled');
    });
  }
}

function handleFreeGift() {
  // If already processing, don't start another operation
  if (freeGiftProcessing) {
    return;
  }
  
  // Clear any existing timeout
  if (freeGiftTimeout) {
    clearTimeout(freeGiftTimeout);
  }
  
  // Set a timeout to prevent rapid successive calls
  freeGiftTimeout = setTimeout(function() {
    // Set processing flag to true
    freeGiftProcessing = true;
    
    // First, fetch the latest cart data to ensure we have current information
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        const miniCartElement = document.querySelector('.mini-cart__inner');
        if (!miniCartElement) {
          freeGiftProcessing = false;
          enableMiniCartButton();
          return;
        }
        
        // Setup cart note toggle functionality
        $(document).off('change', '#CartNoteToggle').on('change', '#CartNoteToggle', function() {
          const isChecked = $(this).is(':checked');
          $('.cart-note-wrapper').css('display', isChecked ? 'block' : 'none');
          
          // Add or remove class to mini-cart__inner based on cart note visibility
          if (isChecked) {
            $('.mini-cart__inner').addClass('has-cart-note');
          } else {
            $('.mini-cart__inner').removeClass('has-cart-note');
          }
        });
        
        // Initialize class on page load if cart note is visible
        if ($('#CartNoteToggle').is(':checked')) {
          $('.mini-cart__inner').addClass('has-cart-note');
        }
        
        // Get the free gift threshold from the data attribute
        const freeGiftThreshold = parseInt(miniCartElement.dataset.freeGiftThreshold || 0);
        const freeGiftVariantId = miniCartElement.dataset.freeGiftVariantId;
        
        // Use the current cart total from the fetched cart data
        const currentCartTotal = cart.total_price;
        
        // Update the data attribute with the current cart total
        miniCartElement.dataset.cartTotal = currentCartTotal;
        
        if (!freeGiftVariantId || freeGiftVariantId === 'null') {
          freeGiftProcessing = false;
          enableMiniCartButton();
          return;
        }
        
        // Check for ALL instances of the free gift product in cart, regardless of properties
        let freeGiftItems = [];
        let freeGiftWithPropertiesCount = 0;
        let freeGiftTotalCount = 0;
        
        for (const item of cart.items) {
          if (item.variant_id.toString() === freeGiftVariantId) {
            freeGiftTotalCount += item.quantity;
            freeGiftItems.push({
              key: item.key,
              quantity: item.quantity,
              hasProperties: item.properties && item.properties._free_gift === 'true'
            });
            
            if (item.properties && item.properties._free_gift === 'true') {
              freeGiftWithPropertiesCount += item.quantity;
            }
          }
        }
        
        // Update the data attributes with the current state
        miniCartElement.dataset.freeGiftInCart = (freeGiftWithPropertiesCount > 0).toString();
        miniCartElement.dataset.freeGiftCartItemKey = freeGiftWithPropertiesCount > 0 ? 
          freeGiftItems.find(item => item.hasProperties).key : '';
        
        // Handle cases where there are multiple free gift items (either the same or different variants)
        if (freeGiftTotalCount > 1) {
          // If there's more than 1 free gift item in the cart, we need to ensure only one remains
          // Create an updates object to modify quantities
          const updates = {};
          
          // Strategy: 
          // 1. Keep one item with _free_gift property if it exists
          // 2. Otherwise keep the first item we found
          let keptOne = false;
          
          freeGiftItems.forEach(item => {
            if (!keptOne && (item.hasProperties || (freeGiftWithPropertiesCount === 0))) {
              updates[item.key] = 1; // Keep this one
              keptOne = true;
            } else {
              updates[item.key] = 0; // Remove all others
            }
          });
          
          // Update the cart
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function(data) {
              refreshCartDrawer();
              setTimeout(function() {
                freeGiftProcessing = false;
                enableMiniCartButton();
              }, 2000);
            },
            error: function(xhr, status, error) {
              freeGiftProcessing = false;
              enableMiniCartButton();
            }
          });
          
          // Return early to prevent other operations
          return;
        }
        
        // Now handle the threshold-based logic
        // Case 1: Cart total meets threshold but no free gift with properties - add one if there isn't any free gift at all
        if (currentCartTotal >= freeGiftThreshold && freeGiftWithPropertiesCount === 0 && freeGiftTotalCount === 0) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: [{
                id: freeGiftVariantId,
                quantity: 1,
                properties: {
                  '_free_gift': 'true'
                }
              }]
            },
            dataType: 'json',
            success: function(data) {
              refreshCartDrawer();
              setTimeout(function() {
                freeGiftProcessing = false;
                enableMiniCartButton();
              }, 2000);
            },
            error: function(xhr, status, error) {
              freeGiftProcessing = false;
              enableMiniCartButton();
            }
          });
        } 
        // Case 2: Cart total below threshold but free gift with properties exists - remove it
        else if (currentCartTotal < freeGiftThreshold && freeGiftWithPropertiesCount > 0) {
          // Create an array of update operations for each free gift
          const updates = {};
          freeGiftItems.forEach(item => {
            if (item.hasProperties) {
              updates[item.key] = 0; // Set quantity to 0 to remove
            }
          });
          
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            success: function(data) {
              // Enable button immediately when free gift is removed
              enableMiniCartButton();
              refreshCartDrawer();
              setTimeout(function() {
                freeGiftProcessing = false;
                enableMiniCartButton();
              }, 2000);
            },
            error: function(xhr, status, error) {
              freeGiftProcessing = false;
              enableMiniCartButton();
            }
          });
        }
        // Case 3: Cart total meets threshold but free gift is manually added without properties
        else if (currentCartTotal >= freeGiftThreshold && freeGiftWithPropertiesCount === 0 && freeGiftTotalCount === 1) {
          // Convert the existing manually-added free gift to have the free gift property
          const updates = {};
          const manualItem = freeGiftItems.find(item => !item.hasProperties);
          
          if (manualItem) {
            // Remove the item without properties
            updates[manualItem.key] = 0;
            
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function() {
                // Then add it back with the free gift property
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    items: [{
                      id: freeGiftVariantId,
                      quantity: 1,
                      properties: {
                        '_free_gift': 'true'
                      }
                    }]
                  },
                  dataType: 'json',
                  success: function(data) {
                    refreshCartDrawer();
                    setTimeout(function() {
                      freeGiftProcessing = false;
                      enableMiniCartButton();
                    }, 2000);
                  },
                  error: function() {
                    freeGiftProcessing = false;
                    enableMiniCartButton();
                  }
                });
              },
              error: function() {
                freeGiftProcessing = false;
                enableMiniCartButton();
              }
            });
          } else {
            freeGiftProcessing = false;
            enableMiniCartButton();
          }
        } else {
          // No action needed
          freeGiftProcessing = false;
          enableMiniCartButton();
        }
      },
      error: function(xhr, status, error) {
        // Reset processing flag on error
        freeGiftProcessing = false;
        enableMiniCartButton();
      }
    });
  }, 300); // Small delay to debounce multiple calls
}

// Function to refresh the cart drawer without page reload
function refreshCartDrawer() {
  // First, fetch the latest cart data
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      // Update cart count in the header if it exists
      if ($('.cart-count-bubble').length) {
        $('.cart-count-bubble').text(cart.item_count);
      }
      
      // Get the mini-cart component
      const miniCartElement = document.querySelector('mini-cart');
      
      if (miniCartElement) {
        // Create a response object similar to what the theme expects
        const sectionsToRender = miniCartElement.getSectionsToRender ? 
                                miniCartElement.getSectionsToRender() : 
                                [
                                  {
                                    id: 'mini-cart',
                                    section: 'mini-cart',
                                    selector: '.shopify-section'
                                  },
                                  {
                                    id: 'cart-icon-bubble',
                                    section: 'cart-icon-bubble',
                                    selector: '.shopify-section'
                                  }
                                ];
        
        // Fetch all the sections we need to update
        const sectionPromises = sectionsToRender.map(section => {
          return fetch(`${window.location.pathname}?section_id=${section.section}`)
            .then(response => response.text())
            .then(responseText => {
              return { id: section.id, html: responseText };
            });
        });
        
        Promise.all(sectionPromises)
          .then(sections => {
            // Create a response object similar to what the cart/add.js endpoint returns
            const sectionsObject = {};
            sections.forEach(section => {
              sectionsObject[section.id] = section.html;
            });
            
            const response = {
              sections: sectionsObject
            };
            
            // Call the native renderContents method
            if (typeof miniCartElement.renderContents === 'function') {
              miniCartElement.renderContents(response);
            } else {
              // Fallback if renderContents is not available
              
              // Try to open the drawer
              if (typeof miniCartElement.open === 'function') {
                miniCartElement.open();
              } else {
                // Last resort: trigger a click on the cart icon
                const cartButton = document.querySelector('.header__icon--cart');
                if (cartButton) {
                  cartButton.click();
                }
              }
            }
            
            // Ensure the mini cart button is enabled after refresh
            setTimeout(function() {
              enableMiniCartButton();
            }, 100);
          })
          .catch(error => {
            // Silent error handling for production
          });
      } else {
        // Fallback to section rendering API
        fetch(window.location.pathname + '?section_id=mini-cart')
          .then(response => response.text())
          .then(html => {
            // Create a temporary div to hold the response
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            
            // Find the cart items container in the fetched HTML
            const newCartItems = tempDiv.querySelector('#main-cart-items');
            if (newCartItems && $('#main-cart-items').length) {
              $('#main-cart-items').html(newCartItems.innerHTML);
            }
            
            // Update the subtotal if it exists
            const newSubtotal = tempDiv.querySelector('.sub_val');
            if (newSubtotal && $('.sub_val').length) {
              $('.sub_val').text(newSubtotal.textContent);
            }
            
            // Update the cart progress bar if it exists
            const newProgressBar = tempDiv.querySelector('.cart_progress');
            if (newProgressBar && $('.cart_progress').length) {
              $('.cart_progress').html(newProgressBar.innerHTML);
            }
            
            // Try to open the drawer if it's not already open
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.openMenuDrawer === 'function') {
              cartDrawer.openMenuDrawer();
            }
            
            // Dispatch cart:updated event to trigger any other updates
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cart, source: 'free-gift-refresh' }
            }));
            
            // Ensure the mini cart button is enabled after refresh
            setTimeout(function() {
              enableMiniCartButton();
            }, 100);
          })
          .catch(error => {
            // Silent error handling for production
          });
      }
    },
    error: function(xhr, status, error) {
      // Silent error handling for production
    }
  });
}

// Initialize the functionality when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Add event listeners for cart quantity changes and item removal
  document.addEventListener('click', function(event) {
    // Check for plus/minus buttons and delete buttons
    const target = event.target;
    const isPlusMinusButton = target.matches('.quantity__button') || 
                              target.matches('[data-action="increment"]') || 
                              target.matches('[data-action="decrement"]') ||
                              target.matches('.qty-btn') ||
                              target.matches('.quantity-selector button') ||
                              target.closest('.quantity__button') ||
                              target.closest('[data-action="increment"]') ||
                              target.closest('[data-action="decrement"]') ||
                              target.closest('.qty-btn');
    
    const isDeleteButton = target.matches('.delete-product') ||
                           target.matches('.cart-item__remove') ||
                           target.matches('[data-action="remove"]') ||
                           target.matches('.remove-item') ||
                           target.closest('.delete-product') ||
                           target.closest('.cart-item__remove') ||
                           target.closest('[data-action="remove"]') ||
                           target.closest('.remove-item');
    
    if (isPlusMinusButton || isDeleteButton) {
      // Disable checkout button immediately
      disableMiniCartButton();
    }
  });
  
  // Also listen for quantity input changes
  document.addEventListener('change', function(event) {
    const target = event.target;
    const isQuantityInput = target.matches('input[name*="quantity"]') ||
                           target.matches('.quantity__input') ||
                           target.matches('[data-quantity-input]') ||
                           target.closest('.quantity__input');
    
    if (isQuantityInput) {
      // Disable checkout button immediately
      disableMiniCartButton();
    }
  });
  
  // Run when cart drawer is opened
  document.addEventListener('cartdrawer:opened', function(event) {
    handleFreeGift();
  });
  
  // Run when cart is updated
  document.addEventListener('cart:update', function(event) {
    // Only run if the source is not from our own free gift operations
    if (!event.detail || (event.detail.source !== 'free-gift-add' && event.detail.source !== 'free-gift-remove')) {
      handleFreeGift();
    }
  });
  
  // Also listen for the theme's specific cart update events
  document.addEventListener('cart:updated', function(event) {
    handleFreeGift();
  });
  
  document.addEventListener('cart:refresh', function(event) {
    handleFreeGift();
  });
  
  // Listen for product form submissions
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      // We don't prevent default here because we want the form to submit normally
      
      // Set a timeout to run handleFreeGift after the form submission completes
      setTimeout(function() {
        handleFreeGift();
      }, 500);
    });
  });
  
  // Also intercept any AJAX add-to-cart buttons
  document.addEventListener('click', function(event) {
    const addToCartButton = event.target.closest('[data-add-to-cart]') || 
                            event.target.closest('.product-form__submit') ||
                            event.target.closest('.add-to-cart');
    
    if (addToCartButton) {
      // Set a timeout to run handleFreeGift after the AJAX request completes
      setTimeout(function() {
        handleFreeGift();
      }, 1000);
    }
  });
  
  // Intercept the ProductForm class's onSubmitHandler
  // This is a more reliable way to catch all product form submissions
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const fetchPromise = originalFetch.apply(this, arguments);
    
    // Check if this is a cart/add request
    if (url && url.includes('/cart/add')) {
      fetchPromise.then(function(response) {
        // Wait for the response to complete, then run handleFreeGift
        setTimeout(function() {
          handleFreeGift();
        }, 500);
        return response;
      });
    }
    
    return fetchPromise;
  };
  
  // Initial check
  handleFreeGift();
  
  // jQuery fallback for cart interactions (if jQuery is available)
  if (typeof $ !== 'undefined') {
    // Listen for clicks on plus/minus and delete buttons using jQuery
    $(document).on('click', '.quantity__button, [data-action="increment"], [data-action="decrement"], .qty-btn, .delete-product, .cart-item__remove, [data-action="remove"], .remove-item', function() {
      disableMiniCartButton();
    });
    
    // Listen for quantity input changes using jQuery
    $(document).on('change', 'input[name*="quantity"], .quantity__input, [data-quantity-input]', function() {
      disableMiniCartButton();
    });
  }
});